export default {
  level: state => state.user.level
}
